import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthentictionService } from '../../services/authentiction.service';
import { Router } from '@angular/router';
import { UtilService } from '../../services/util.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit{
  public isLoading: boolean = false;
  public user: any = {
    username: ''
  };

  constructor(private authService:AuthentictionService,private router:Router,private utilService:UtilService){

  }

  ngOnInit(): void {
    
  }

  onSubmit(form: NgForm) {
    if(form.valid){
      console.log(this.user.username);
      this.isLoading = true;
      let param ={
        email:this.user.username
      }
      this.authService.forgotPassword(param).subscribe((res:any) =>{
        console.log(res.message);
        this.utilService.showSuccess(res.message)
        this.router.navigate(['/login']);
        
      },(err:any) =>{
        this.isLoading = false;
        if(err.status==401){
          this.utilService.showErrorToast(err.error.message)
          console.log(err);
          
        }else if(err.status == 400){
          console.log(err);
          this.utilService.showErrorToast(err.error.errors.email)
        }
      }
    );
  }
  }
}
